module.exports = __webpack_public_path__ + "img/details.c17d9fb6.png";